import Vue from 'vue'
import VueRouter from 'vue-router'
import PaymentPage from "@/views/PaymentPage.vue";


Vue.use(VueRouter)

export default new VueRouter({
    mode: 'history',
    linkActiveClass: 'open active',
    scrollBehavior: () => ({ y: 0 }),
    routes: [
        {
            path: '/', component: PaymentPage
        }
    ]
});
